import skillsData from "../data/skills.json";
import { getEffective } from "./applyHomebrew"
import { speciesSkillMods, modTargetSkills } from "./SpeciesSkillMods"

const GEAR_SKILL_CAP = 5;
const CYBER_SKILL_CAP = 6;

const FreeRanks = (character, { includeGear = true } = {}) => {
    const skills = getEffective('skills', skillsData);

    var freeRanks = [];
    function addFreeRank(skill, rank) {
        freeRanks[skill] = parseInt(freeRanks[skill] || 0) + parseInt(rank);
    }

    if (character.Species.SelectedSkills && character.Species.SelectedSkills[0]) {
        character.Species.SelectedSkills.forEach((skill) => {
            addFreeRank(skills.find((s) => skill === s.skill).Key, 1);
        });
    }

    speciesSkillMods(character.Species).forEach((mod) => {
        const ranks = parseInt(mod.RankStart) || 0;
        if (ranks) modTargetSkills(mod, skills).forEach((s) => addFreeRank(s.Key, ranks));
    });

    if (character.Species.OptionChoices) {
        if (character.Species.OptionChoices[0]) {
            for (let oc in character.Species.OptionChoices) {
                let optionChoice = character.Species.OptionChoices[oc]
                if (optionChoice.Options && Array.isArray(optionChoice.Options) && optionChoice.Selected) {
                    // Support both checklist (array Selected) and single-select (string Selected)
                    const selectedKeys = Array.isArray(optionChoice.Selected) ? optionChoice.Selected : [optionChoice.Selected];
                    selectedKeys.forEach(key => {
                        const selectedOpt = optionChoice.Options.find((o) => o.Key === key);
                        if (selectedOpt?.SkillModifiers) {
                            const mods = Array.isArray(selectedOpt.SkillModifiers) ? selectedOpt.SkillModifiers : [selectedOpt.SkillModifiers];
                            mods.forEach(mod => addFreeRank(mod.Key, mod.RankAdd || mod.RankStart));
                        }
                    });
                }
            }
        } else if (character.Species.OptionChoices.Options && character.Species.OptionChoices.Options[0] && character.Species.OptionChoices.Options[0].SkillModifiers && character.Species.OptionChoices.Selected) {
            let skillOption = character.Species.OptionChoices.Options.find((o) => o.Key === character.Species.OptionChoices.Selected)
            addFreeRank(skillOption.SkillModifiers.Key, skillOption.SkillModifiers.RankStart)
        }
    }

    if (character.Species.OptionSelectedSkills) {
        for (const skillList of Object.values(character.Species.OptionSelectedSkills)) {
            if (Array.isArray(skillList)) {
                skillList.forEach(skillName => {
                    const skill = skills.find(s => s.skill === skillName);
                    if (skill) addFreeRank(skill.Key, 1);
                });
            }
        }
    }

    if (
        character.Species.SubSpeciesList &&
        character.Species.SubSpeciesList.find((ss) => ss.Key === character.Species.SubSpecies) &&
        character.Species.SubSpeciesList.find((ss) => ss.Key === character.Species.SubSpecies)
            .OptionChoices &&
        character.Species.SubSpeciesList.find((ss) => ss.Key === character.Species.SubSpecies)
            .OptionChoices[0] &&
        character.Species.SubSpeciesList.find((ss) => ss.Key === character.Species.SubSpecies)
            .OptionChoices[0].Selected &&
        character.Species.SubSpeciesList.find((ss) => ss.Key === character.Species.SubSpecies)
            .OptionChoices[0].Options.find((o) => o.Key ===
                character.Species.SubSpeciesList.find((ss) => ss.Key === character.Species.SubSpecies)
                    .OptionChoices[0].Selected
            ).SkillModifiers
    ) {
        addFreeRank(
            character.Species.SubSpeciesList.find((ss) => ss.Key === character.Species.SubSpecies)
                .OptionChoices[0].Options.find((o) => o.Key ===
                    character.Species.SubSpeciesList.find((ss) => ss.Key === character.Species.SubSpecies)
                        .OptionChoices[0].Selected
                ).SkillModifiers.Key,
            character.Species.SubSpeciesList.find((ss) => ss.Key === character.Species.SubSpecies)
                .OptionChoices[0].Options.find((o) => o.Key ===
                    character.Species.SubSpeciesList.find((ss) => ss.Key === character.Species.SubSpecies)
                        .OptionChoices[0].Selected
                ).SkillModifiers.RankStart,
        );
    }
    if (character.CareerRanks) {
        for (let r in character.CareerRanks) {
            const match = skills.find(
                (Skill) => Skill.skill === character.CareerRanks[r],
            );
            if (match) addFreeRank(match.Key, 1);
        }
    }

    if (character.SpecRanks) {
        for (let r in character.SpecRanks) {
            const match = skills.find(
                (Skill) => Skill.skill === character.SpecRanks[r],
            );
            if (match) addFreeRank(match.Key, 1);
        }
    }

    if (!includeGear) return freeRanks;

    // Gear Ranks
    const gearRanks = {};
    function addGearRank(item, mod) {
        if (!skills.find(s => s.Key === mod.Key) || !mod.Count) return;
        const bucket = item.Type === "Cybernetics" ? "cyber" : "regular";
        gearRanks[mod.Key] = gearRanks[mod.Key] || { regular: 0, cyber: 0 };
        gearRanks[mod.Key][bucket] += parseInt(mod.Count) || 0;
    }
    for (const list of [character.Gear, character.Armor, character.Weapons]) {
        for (let g in list) {
            const item = list[g];
            if (!item?.Equipped || !item.BaseMods) continue;
            if (item.BaseMods.Key) addGearRank(item, item.BaseMods);
            else if (Array.isArray(item.BaseMods)) item.BaseMods.forEach(mod => addGearRank(item, mod));
        }
    }

    // Gear Rank Caps
    for (const key of Object.keys(gearRanks)) {
        const purchased = parseInt(character.Skills?.find(s => s.Key === key)?.value) || 0;
        const base = purchased + (parseInt(freeRanks[key]) || 0);
        const afterRegular = Math.max(base, Math.min(GEAR_SKILL_CAP, base + gearRanks[key].regular));
        const afterCyber = Math.max(afterRegular, Math.min(CYBER_SKILL_CAP, afterRegular + gearRanks[key].cyber));
        if (afterCyber > base) addFreeRank(key, afterCyber - base);
    }

    return freeRanks;
};
export default FreeRanks;
